export const SectionTitle = ({ children }) => (
  <div style={{ fontSize: 11, fontWeight: 500, color: "#999", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 10, marginTop: 4, fontFamily: "'DM Sans', sans-serif" }}>{children}</div>
);
